import { useMemo } from 'react';
import { useAccountsPipeline } from '@/lib/useAccountsPipeline';
import {
  buildDashboardAggregates,
  type DashboardAggregates,
} from '@/lib/dashboardAggregates';

interface DashboardState {
  aggregates: DashboardAggregates;
  accounts: ReturnType<typeof useAccountsPipeline>['accounts'];
  loading: boolean;
}

export function useDashboardAggregates(): DashboardState {
  const { accounts, loading } = useAccountsPipeline();
  const aggregates = useMemo(
    () => buildDashboardAggregates(accounts),
    [accounts],
  );
  return { aggregates, accounts, loading };
}
